// 防抖debounce代码：
export function debounce (fn, delay = 1000) {
    var timeout = null // 创建一个标记用来存放定时器的返回值
    return function () {
      // 每当用户输入的时候把前一个 setTimeout clear 掉
      clearTimeout(timeout)
      // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
      timeout = setTimeout(() => {
        console.log('ok')
        fn.apply(this, arguments)
      }, delay)
    }
  }

  /*
  * Javascript base64encode() base64加密函数
    用于生成字符串对应的base64加密字符串
  * @param string input 原始字符串
  * @return string 加密后的base64字符串
*/
export function base64Encode (input) {
  let rv = ''
  rv = encodeURIComponent(input)
  console.log(222, rv)
  rv = unescape(rv)
  rv = window.btoa(rv)
  return rv
}

/**
 * 生成n位随机数
 * @param { Number }
 * @return { Number }
 */
export function randNumber (n) {
  var rnd = ''
  for (var i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10)
  }
  return rnd
}



  export default {
    debounce,
    base64Encode,
    randNumber
  }